// extracted by mini-css-extract-plugin
module.exports = {"group":"UserGroup_group__qwvmB","icon":"UserGroup_icon__25Yuf"};